const fallbackLSObj = {} as any;

const fallbackLS = (key: string, value?: string) => {
	if (value === undefined) {
		return fallbackLSObj[key];
	}
	if (value === null) {
		delete fallbackLSObj[key];
		return null;
	}
	fallbackLSObj[key] = value;
	return null;
};

const storageValue = (key: string, value?: string) => {
	try {
		if (value === undefined) {
			return window.localStorage.getItem(key);
		}
		if (value === null) {
			return window.localStorage.removeItem(key);
		}
		return window.localStorage.setItem(key, value);
	} catch (error) {
		return fallbackLS(key, value);
	}
};

export default storageValue;
